import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { MaintainTableComponent } from './components/views/maintain/maintain-table/maintain-table.component';
import { SignInComponent } from './components/views/sign-in/sign-in.component';
import { NotFoundComponent } from './components/views/not-found/not-found.component';
import { MaintainFormComponent } from './components/views/maintain/maintain-form/maintain-form.component';
import { EntityDetailsMode } from './components/views/maintain/maintain-form/maintain-form-mode.enum';
import { EntityGroupDetailsComponent } from './components/views/entity-group/entity-group-details/entity-group-details.component';
import { MainTableV2Component } from './components/views/main-table-v2/main-table-v2.component';
import { AutoWithdrawalsConfigComponent } from './components/views/custom-views/auto-withdrawals-config/auto-withdrawals-config.component';
import { DepositTickeActionRulesComponent } from './components/views/custom-views/deposit-ticke-action-rules/deposit-ticke-action-rules.component';
import { PermissionType } from './core/models/permission';

export const contentRoutes: Routes = [
  {
    path: 'deposit-action-rules',
    component: DepositTickeActionRulesComponent,
    data: {
      permission: PermissionType.SETTINGS_PAYMENTS,
      mode: EntityDetailsMode.VIEW,
    },
  },
  {
    path: 'auto-withdrawals-config',
    component: AutoWithdrawalsConfigComponent,
    data: {
      permission: PermissionType.SETTINGS_PAYMENTS,
      mode: EntityDetailsMode.VIEW,
    },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'draws-dashboard/single/overall',
  },
  {
    path: 'v2/:entityCode',
    component: MainTableV2Component,
  },
  {
    path: ':entityCode',
    component: MaintainTableComponent,
  },
  {
    path: ':entityCode/add',
    component: MaintainFormComponent,
    data: {
      mode: EntityDetailsMode.ADD,
    },
  },
  {
    path: ':entityCode/group/add',
    component: EntityGroupDetailsComponent,
    data: {
      mode: EntityDetailsMode.ADD,
    },
  },
  {
    path: ':entityCode/:entityId',
    component: MaintainFormComponent,
    data: {
      mode: EntityDetailsMode.VIEW,
    },
  },
  {
    path: ':entityCode/:entityId/edit',
    component: MaintainFormComponent,
    data: {
      mode: EntityDetailsMode.EDIT,
    },
  },
  {
    path: ':entityCode/:entityId/:groupId',
    component: EntityGroupDetailsComponent,
    data: {
      mode: EntityDetailsMode.VIEW,
      ziom: 'ziom',
    },
  },
  {
    path: ':entityCode/:entityId/:groupId/edit',
    component: EntityGroupDetailsComponent,
    data: {
      mode: EntityDetailsMode.EDIT,
    },
  },
  {
    path: ':entityCode/:entityId/:groupId/:groupEntityId',
    component: EntityGroupDetailsComponent,
    data: {
      mode: EntityDetailsMode.VIEW,
    },
  },
];

const routes: Routes = [
  {
    path: 'sso',
    component: SignInComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'manage',
  },
  {
    path: 'manage',
    loadChildren: () => import('./feature/manage/manage.module').then((m) => m.ManageModule),
  },
  {
    path: 'settings',
    loadChildren: () => import('./feature/settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: 'legacy',
    redirectTo: 'manage',
    pathMatch: 'prefix',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
